<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.name')" type="text" v-model="employee.name"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.address')" type="text" v-model="employee.address"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.phone')" type="text" v-model="employee.phone"></CInput>
            </div>
            <div class="col-6">
              <CInput readonly :label="$t('fields.personal_id')" type="text" v-model="employee.personal_id"></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput readonly :label="$t('fields.payment_type_placeholder')" type="text" v-model="employee.payment_type"></CInput>
            </div>
            <div class="col-6">
              <div class="form-group" role="group">
                <label>{{ $t('fields.is_active') }}</label>
                <div>
                  <CBadge 
                    :color="employee.status_class">
                    {{ employee.status ? $t('fields.active') : $t('fields.inactive') }}
                  </CBadge>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
               <CTextarea readonly :label="$t('fields.comment')" v-model="employee.comment"></CTextarea>
            </div>
          </div>
          <CButton v-if="permissions.employees.edit" color="success" @click="editEmployee">
            <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}
          </CButton>
          <CButton color="primary" @click="goBack">
            <CIcon :content="$options.backIcon" /> {{ $t('button.back') }}
          </CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormEmployee',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  data() {
    return {
        employee: {
          name: '',
          address: '',
          phone: '',
          personal_id: '',
          payment_type: '',
          comment: '',
          status: 0
        },
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ]
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    })
  },
  mounted() {
    if (this.isEditing) {
        this.getEmployee();
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Employees' });
    },editEmployee() {
      const id = this.$route.params.id;
      this.$router.push({ name: 'EditEmployee', params: {id} });
    },
    getEmployee() {
        const id = this.$route.params.id;
        axios.get('/api/employees/'+ id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            this.employee = response.data;
            this.employee.status_class = this.employee.status ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    }
  }
}

</script>